import { useContext } from 'react';

import CustomersContext from './CustomersContext';

const useCustomers = () => {
  return useContext(CustomersContext);
};

export default useCustomers;
